export default "__VITE_ASSET__Df5xACaD__"